<template>


    <div class="footer">
        <div class="row justify-content-between align-items-center">
            <div class="col">
                <p class="fs-6 mb-0">&copy; CPD | Présidence de la République du B&Eacute;NIN <span
                        class="d-none d-sm-inline-block" id="year-span"> 2022 - 2025</span></p>
            </div>
            <!-- End Col -->

            <div class="col-auto">
                <div class="d-flex justify-content-end">

                </div>
            </div>
            <!-- End Col -->
        </div>
        <!-- End Row -->
    </div>
</template>

<script>
    export default {
        name:"FooterAdmin",
        
    }
</script>